import { Text } from "./Text.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { Flex, Spacer } from "./Flex.mjs";
import { Icon } from "./Icon.mjs";
import { Button as Button$1 } from "./Button.mjs";
import { useStyles } from "purse-styles";
import React, { useContext } from "react";
import { Dialog, DialogTrigger, Modal, OverlayTriggerStateContext } from "react-aria-components";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/Dialog.tsx
const WithDialog = ({ children, dialog, title, isOpen, onOpenChange, isDismissable = true }) => {
	const theme = useTheme();
	const modalClassName = useStyles({
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 1e3,
		transition: `opacity ${theme.transitions.fast.duration}ms ${theme.transitions.fast.easing}`,
		"&[data-entering]": { opacity: 0 },
		"&[data-exiting]": { opacity: 0 },
		"@media (prefers-reduced-motion: reduce)": { transition: "none" }
	});
	const dialogClassName = useStyles({
		backgroundColor: theme.colors.sand1,
		border: `1px solid ${theme.colors.sandA5}`,
		borderRadius: theme.borderRadiuses.lg,
		padding: theme.spacing.lg,
		minWidth: "400px",
		maxWidth: "600px",
		boxShadow: theme.shadows.default,
		outline: "none",
		transformOrigin: "center center",
		transform: "scale(1)",
		transition: `opacity ${theme.transitions.normal.duration}ms ${theme.transitions.normal.easing}, transform ${theme.transitions.normal.duration}ms ${theme.transitions.normal.easing}`,
		"&[data-entering]": {
			opacity: 0,
			transform: "scale(0.8)"
		},
		"&[data-exiting]": {
			opacity: 0,
			transform: "scale(0.8)"
		},
		"@media (prefers-reduced-motion: reduce)": { transition: "none" }
	});
	return /* @__PURE__ */ jsxs(DialogTrigger, {
		isOpen,
		onOpenChange,
		children: [children ?? /* @__PURE__ */ jsx("button", {
			type: "button",
			tabIndex: -1,
			"aria-hidden": true,
			style: { display: "none" }
		}), /* @__PURE__ */ jsx(Modal, {
			isDismissable,
			className: modalClassName,
			children: /* @__PURE__ */ jsxs(Dialog, {
				className: dialogClassName,
				children: [
					/* @__PURE__ */ jsxs(Flex, {
						align: "center",
						justify: "space-between",
						children: [/* @__PURE__ */ jsx(Text, {
							size: "lg",
							weight: "semibold",
							children: title
						}), isDismissable ? /* @__PURE__ */ jsx(Button$1, {
							internal_slot: "close",
							size: "sm",
							variant: "ghost",
							children: /* @__PURE__ */ jsx(Icon, { name: "X" })
						}) : null]
					}),
					/* @__PURE__ */ jsx(Spacer, { height: "md" }),
					dialog
				]
			})
		})]
	});
};
function useDialog() {
	const dialogContext = useContext(OverlayTriggerStateContext);
	if (!dialogContext) throw new Error("Dialog context not found");
	return dialogContext;
}

//#endregion
export { WithDialog, useDialog };